/* Ergovanta sub-brand lookbook page enhancements (2026-06-23).
   On the eg-hpdp product lookbook section:
   - Move the "Back to <room>" link to the TOP, as a smart back button
     (history-back when the visitor came from within the site, else the room).
   - Reformat the two bulk-quote CTAs: a quiet "Request a bulk quote" label
     above two compact buttons ("Text us...", "Email us...").
   - Move the retail link up under the lead and reword it for 1-10 units.
   (Hero is shrunk via eg-subbrand-enhance.css.) Pure one-time DOM work;
   the page does not AJAX re-render, so no observer needed. */
(function () {
  function run() {
    var sec = document.querySelector('.eg-hpdp');
    if (!sec || sec.hasAttribute('data-eg-enhanced')) return;
    sec.setAttribute('data-eg-enhanced', '1');
    var content = sec.querySelector('.eg-hpdp__content');

    var actions = Array.prototype.slice.call(sec.querySelectorAll('.eg-hpdp__actions .eg-hpdp__action'));
    var smsLink = null, mailLink = null, backLink = null;
    actions.forEach(function (a) {
      var h = a.getAttribute('href') || '';
      if (h.indexOf('sms:') === 0) smsLink = a;
      else if (h.indexOf('mailto:') === 0) mailLink = a;
      else backLink = a;
    });

    // 1. Smart back button at the top.
    if (backLink && !sec.querySelector('.eg-hpdp__topbar')) {
      var href = backLink.getAttribute('href');
      var label = backLink.textContent.replace(/^[\s ←<-]+/, '').trim() || 'Back';
      var bar = document.createElement('div');
      bar.className = 'eg-hpdp__topbar';
      var a = document.createElement('a');
      a.className = 'eg-hpdp__back';
      a.setAttribute('href', href);
      a.innerHTML = '<span class="eg-hpdp__back-arrow" aria-hidden="true">&larr;</span> ' + label;
      a.addEventListener('click', function (e) {
        if (document.referrer && document.referrer.indexOf(location.origin) === 0 && history.length > 1) {
          e.preventDefault();
          history.back();
        }
      });
      bar.appendChild(a);
      sec.insertBefore(bar, sec.firstChild);
      backLink.remove();
    }

    // 2. Reformat the bulk-quote CTAs.
    var actionsWrap = sec.querySelector('.eg-hpdp__actions');
    if (actionsWrap && (smsLink || mailLink) && !sec.querySelector('.eg-hpdp__bulk-label')) {
      var lbl = document.createElement('p');
      lbl.className = 'eg-hpdp__bulk-label';
      lbl.textContent = 'Request a bulk quote';
      actionsWrap.parentNode.insertBefore(lbl, actionsWrap);
      if (smsLink) { var t1 = smsLink.querySelector('.eg-hpdp__action-text'); if (t1) t1.textContent = 'Text us · (201) 374-0918'; }
      if (mailLink) { var t2 = mailLink.querySelector('.eg-hpdp__action-text'); if (t2) t2.textContent = 'Email us · info@ergovanta.com'; }
    }

    // 3. Retail link: reword + move up under the lead.
    var retail = sec.querySelector('.eg-hpdp__retail-line');
    if (retail && content) {
      var rl = retail.querySelector('a');
      if (rl) rl.innerHTML = 'Prefer 1-10 units? Shop them at retail&nbsp;<span aria-hidden="true">&rarr;</span>';
      var anchor = content.querySelector('.eg-hpdp__lead') || content.querySelector('.eg-hpdp__name');
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(retail, anchor.nextSibling);
      retail.classList.add('eg-hpdp__retail-line--top');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
